import React, { useState } from 'react';
import { toast } from 'sonner';

export const levelTestsThisYear = (u) =>
  Number(u?.level_tests_year) === new Date().getFullYear() ? Number(u?.level_tests_count || 0) : 0;

// Click n = n tests done this year; click the current number again to undo one.
export const LevelTestPicker = ({ user, API, L, onChange }) => {
  const [count, setCount] = useState(levelTestsThisYear(user));
  const [saving, setSaving] = useState(false);
  const set = async (n) => {
    const next = n === count ? n - 1 : n;
    setSaving(true);
    try {
      await API.put(`/users/${user.id}/level-tests`, { count: next });
      setCount(next);
      onChange?.(next);
    } catch (e) {
      toast.error(e.response?.data?.detail || L('Error', 'Fehler'));
    } finally { setSaving(false); }
  };
  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg bg-indigo-50 border border-indigo-200" data-testid="level-tests-picker">
      <span className="text-xs font-bold text-indigo-700">{L('Level tests', 'Level-Tests')} {new Date().getFullYear()}:</span>
      {[1, 2, 3].map(n => (
        <button key={n} type="button" disabled={saving} onClick={() => set(n)}
          className={`w-6 h-6 rounded-md text-xs font-bold border transition-colors ${n <= count ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white text-indigo-400 border-indigo-200 hover:border-indigo-400'}`}
          data-testid={`level-test-${n}`}>{n}</button>
      ))}
      {count >= 3 && <span className="text-[10px] font-bold uppercase text-indigo-700" data-testid="level-tests-max">{L('max reached', 'Max. erreicht')}</span>}
    </span>
  );
};

export default LevelTestPicker;
